import {ConfigObjectType, useApiQuery} from '@wallaby-ui/core';
import * as React from 'react';
import {useMemo} from 'react';

import {EncounterDetail} from './EncounterDetail';
import {HaidiSchema, WallabyCoreSchema} from 'src/js/common/types';

interface OwnProps {
  config: ConfigObjectType;
  encounterId: string;
  encounterData: HaidiSchema.components['schemas']['EncounterPropertiesDto'] | undefined;
  encounterIsLoading: boolean;
  query: any;
  changeQuery: (newValue: any) => void;
}

type Props = OwnProps;

// V3 method codes for the HAIDI encounter detail charts (replaces legacy WBC/CRP/PCT)
const HAIDI_CHART_EVENT_TYPES = ['CRP_SP', 'WBC_B', 'PCT_SP'] as const;

export const EncounterDetailContainer: React.FC<Props> = (props) => {
  const {config, encounterId, encounterData, encounterIsLoading, query, changeQuery} = props;

  const chartApiV3Url = useMemo(() => {
    const params = new URLSearchParams();
    HAIDI_CHART_EVENT_TYPES.forEach((t) => params.append('labResultEventTypes', t));
    if (query.graph?.dateRange?.startDate && query.graph?.dateRange?.endDate) {
      params.append('startDate', query.graph.dateRange.startDate);
      params.append('endDate', query.graph.dateRange.endDate);
    }
    return `${config.service.url.chart}${encounterId}/chart-v3?${params.toString()}`;
  }, [config.service.url.chart, encounterId, query.graph?.dateRange?.startDate, query.graph?.dateRange?.endDate]);

  const {data: chartDataV3, isLoading: chartIsLoading} = useApiQuery<
    WallabyCoreSchema.components['schemas']['EncounterTimelineChartV3Dto']
  >([chartApiV3Url], null, {
    axiosConfig: {url: chartApiV3Url},
  });

  return (
    <EncounterDetail
      config={config}
      chartData={chartDataV3?.chartData}
      chartRange={[chartDataV3?.startDate, chartDataV3?.endDate]}
      encounterData={encounterData}
      encounterId={encounterId}
      chartIsLoading={chartIsLoading}
      encounterIsLoading={encounterIsLoading}
      query={query}
      changeQuery={changeQuery}
    />
  );
};

EncounterDetailContainer.displayName = 'EncounterDetailContainer';
